import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gaze_user")); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("gaze_token");
    if (t && !user) {
      api.get("/auth/me").then(r => {
        setUser(r.data);
        localStorage.setItem("gaze_user", JSON.stringify(r.data));
      }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function login(email, password) {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gaze_token", data.token);
      localStorage.setItem("gaze_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  }
  function logout() {
    localStorage.removeItem("gaze_token");
    localStorage.removeItem("gaze_user");
    setUser(null);
    window.location.href = "/login";
  }

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() { return useContext(AuthCtx); }
